var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiantGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#020104",
    width: 100,
    height: 60
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.13
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#020104",
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#020205",
    x: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#030206",
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#030306",
    x: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#040307",
    x: 10,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#040408",
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#040409",
    x: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#050509",
    x: 20,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#05050a",
    x: 10,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#05060b",
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#06070c",
    x: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#06070c",
    x: 30,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#06080d",
    x: 20,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#07080e",
    x: 10,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#07090e",
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#070a0f",
    x: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#070a10",
    x: 40,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#070b10",
    x: 30,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080b11",
    x: 20,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080c11",
    x: 10,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080c12",
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080d12",
    x: 60,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080d13",
    x: 50,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#080e13",
    x: 40,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#090f13",
    x: 30,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#090f14",
    x: 20,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#090f14",
    x: 10,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091015",
    x: 70,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091015",
    x: 60,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091115",
    x: 50,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091116",
    x: 40,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091216",
    x: 30,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#091216",
    x: 20,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1317",
    x: 80,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1317",
    x: 70,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1417",
    x: 60,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1418",
    x: 50,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1418",
    x: 40,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1518",
    x: 30,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1518",
    x: 90,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1619",
    x: 80,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0a1619",
    x: 70,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b1619",
    x: 60,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b1719",
    x: 50,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b1719",
    x: 40,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b171a",
    x: 90,
    y: 10,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b181a",
    x: 80,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b181a",
    x: 70,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0b181a",
    x: 60,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c191a",
    x: 50,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c191a",
    x: 90,
    y: 20,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c191a",
    x: 80,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c1a1b",
    x: 70,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0c1a1b",
    x: 60,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0d1a1b",
    x: 90,
    y: 30,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0d1b1b",
    x: 80,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0d1b1b",
    x: 70,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0d1b1b",
    x: 90,
    y: 40,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0e1c1b",
    x: 80,
    y: 50,
    width: 11,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E1C1B",
    x: 90,
    y: 50,
    width: 11,
    height: 11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiantGradient);
export default __webpack_public_path__ + "static/media/radiant-gradient.6b561c68c4607f5c5cee6f597fd454d8.svg";
export { ForwardRef as ReactComponent };